import rootInstance from "../root.js";

export default function() {
	rootInstance.defaults.baseURL = process.env.MIX_GRADESLAM_API_URL;
	return rootInstance;
}
